import { useAppSelector } from 'hooks';
import { useFeatureFlag } from 'hooks/useFeatureFlag';

export const useCommercialAutoSigningEnabled = (): boolean => {
  const isFlagEnabled = useFeatureFlag('enable-commercial-auto-signing');
  const lineOfBusiness = useAppSelector(
    (state) => state.commercialForm.lineOfBusiness,
  );
  const isSigningFlow = useAppSelector(
    (state) => state.commercialForm.data.is_signing_flow,
  );
  const effectiveDate = useAppSelector(
    (state) => state.commercialForm.data.effective_date,
  );
  const isLoa = useAppSelector((state) => state.commercialForm.data.is_loa);
  const applicantProvince = useAppSelector(
    (state) => state.commercialForm.data.applicant_address?.province,
  );

  const isOnOrAfterJuly2026 = !!effectiveDate && effectiveDate >= '2026-07-01';
  const isNotLoa = isLoa !== true && isLoa !== 'yes';
  const isOntario = applicantProvince === 'ON';

  return (
    isFlagEnabled &&
    lineOfBusiness === 'Auto' &&
    isSigningFlow &&
    isOnOrAfterJuly2026 &&
    isNotLoa &&
    isOntario
  );
};
